var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CommandSocketInitializer } from './framework/CommandSocketInitializer';
export class FsrDvT6ss {
    constructor(socket, state, log, framework) {
        this.socket = socket;
        this.state = state;
        // other class properties and constructor
        this.initializerSteps = [
            {
                errorCode: 'verifyFailed',
                send: '#HANDSHAKE',
                next: /<SUCCESS>/i,
            },
        ];
        // controls
        this.busy = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.busy.value;
            }),
        };
        this.firmwareVersion = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`#FW-VERSION?`, /<FW-VERSION\s*([\d\.]+)>/i, tags);
                return match[1];
            }),
        };
        this.videoMatrixRoutes = {
            get: (key, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`#INPUT-SEL?`, /<INPUT-SEL (\d+)>/i, tags);
                return match[1];
            }),
            set: (key, value, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`#INPUT-SEL ${value}`, /<INPUT-SEL (\d+)>/i, tags);
                return match[1];
            }),
            asyncHandlers: [
                {
                    regExp: /<INPUT-SEL (\d+)>/i,
                    callback: (match) => {
                        const value = match[1];
                        this.state.videoMatrixRoutes.update('1', value);
                    },
                },
            ],
        };
        this.volume = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`#AUD-VOL?`, /<AUD-VOL (\d+)>/i, tags);
                return parseInt(match[1], 10);
            }),
            set: (volume, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`#AUD-VOL ${volume}`, /<AUD-VOL (\d+)>/i, tags);
                return parseInt(match[1], 10);
            }),
            range: { max: 100, min: 0, round: 1 },
        };
        this.volumeMute = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`#AUD-MUTE?`, /<AUD-MUTE (\d+)>/i, tags);
                return match[1] === '1';
            }),
            set: (mute, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`#AUD-MUTE ${mute ? '1' : '0'}`, /<AUD-MUTE (\d+)>/i, tags);
                return match[1] === '1';
            }),
        };
        // polling
        this.polls = [
            { intervalMs: 3000, controls: ['videoMatrixRoutes', 'volume'] },
        ];
    }
    // phase callbacks
    onInitialize(credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield CommandSocketInitializer.initialize(this.socket, this.initializerSteps, credentials);
        });
    }
}
// static properties
FsrDvT6ss.driverType = 'socketDriver';
FsrDvT6ss.key = '-MqGncB-qE-aJ47jsIim';
FsrDvT6ss.baseSocketOptions = {
    sendTerminator: '\r',
};
FsrDvT6ss.socketOptions = [
    Object.assign(Object.assign({}, FsrDvT6ss.baseSocketOptions), { port: 23 }),
    Object.assign(Object.assign({}, FsrDvT6ss.baseSocketOptions), { port: 4999 }),
];
